import { Pipe, PipeTransform } from '@angular/core';
import { VideoYoutube } from '@components/video-youtube/models';
import { Image } from '@shared/components/image/models';
import { Video } from '@shared/components/video/models';

@Pipe({
  name: 'isVideo',
  standalone: true,
})
export class IsVideoPipe implements PipeTransform {
  transform(media: Image | Video | VideoYoutube): media is Video {
    return 'url' in media;
  }
}
